import { gql } from "@apollo/client";

export const GET_ALL_TRUCKS_FOR_SELECT_FIELD = gql`

query {
    allTrucks {
        id
        number
        maxLoadInLbs
    }
}
`